import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import { type SxProps } from '@mui/material/styles';

import { Box } from '../box';
import { IconButton } from '../button';
import { CloseRoundedIcon } from '../icons';
import { Image } from '../image';
import { Fade } from '../transition';

interface ImageLightboxProps {
  open: boolean;
  onClose: () => void;
  src: string;
  alt?: string;
  sx?: SxProps;
}

function ImageLightbox(props: Readonly<ImageLightboxProps>) {
  const { open: isOpen, onClose, src, alt } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      slots={{ backdrop: Backdrop }}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={isOpen}>
        <Box>
          <IconButton
            onClick={handleClose}
            type='button'
            sx={(theme) => ({
              position: 'absolute',
              right: theme.spacing(6),
              top: theme.spacing(6),
              color: theme.palette.common.white,
            })}
          >
            <CloseRoundedIcon />
          </IconButton>
          <Image
            src={src}
            alt={alt ?? 'Image'}
            loading='lazy'
            sx={{
              height: '80dvh',
              width: 'auto',
              objectFit: 'contain',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          />
        </Box>
      </Fade>
    </Modal>
  );
}

export { ImageLightbox };
export type { ImageLightboxProps };
